"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsMain = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var uuid_1 = require("uuid");
var core_1 = require("../../../../shared/core");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var analytics_subjects_1 = require("../../analytics-subjects");
var components_1 = require("../../components");
var utils_1 = require("../../components/MeterReadingsData/utils");
var copy_1 = require("../../copy");
var utils_2 = require("../../utils");
var utils_3 = require("../SubmitMeterReading/utils");
var components_2 = require("./components");
var getChildKey = function (key) { return (key ? key : (0, uuid_1.v4)()); };
var SupplySummaryCardContainer = function (_a) {
    var _b;
    var supply = _a.supply, readings = _a.readings, fuelType = _a.fuelType, supplyIndex = _a.supplyIndex, noOfFuelSupplies = _a.noOfFuelSupplies;
    var latestActualReading = (0, react_1.useMemo)(function () {
        return (0, utils_1.getLatestManualReading)(readings);
    }, [readings]);
    var getStatus = function () {
        var isSmart = supply.isSmart, isNonComms = supply.isNonComms, isOnboarding = supply.isOnboarding, isInOMRWindow = supply.isInOMRWindow, msn = supply.msn;
        var hasLatestReading = !!latestActualReading;
        if ((isSmart && !isNonComms) ||
            (isOnboarding && !isInOMRWindow) ||
            (isInOMRWindow && hasLatestReading)) {
            return 'ok';
        }
        if (isInOMRWindow && !hasLatestReading && msn) {
            return 'due';
        }
        if (isSmart && isNonComms) {
            return 'warning';
        }
        if (!isOnboarding && !msn) {
            return 'error';
        }
        return 'ok'; //traditional meters or in OMRWindow with a reading
    };
    return supply.isActive ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READS_SUMMARY_CARD, properties: (_b = {
                    meterData: (0, utils_3.getMeterReadAnalyticsData)(supply, fuelType),
                    status: getStatus()
                },
                _b[core_1.INTERNAL_EVENT_FLAG] = true,
                _b) },
            react_1.default.createElement(components_1.MeterReadingSummaryCard, { isOnboarding: supply.isOnboarding || !supply.isSupplyPointInfoValid, isInOMRWindow: supply.isInOMRWindow, fuelType: fuelType, msn: supply.msn, mpxn: supply.mpxn, noOfFuelSupplies: noOfFuelSupplies, readings: readings, isSmart: supply.isSmart, isNonComms: supply.isNonComms, meterNumOfDigits: supply.meterNumOfDigits, supplyIndex: supplyIndex })))) : null;
};
var MeterReadingsWithData = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, Heading1 = _a.Heading1, Stack = _a.Stack, InfoNotification = _a.InfoNotification;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _b.readings, _c = _b.supplies, gas = _c.gas, electricity = _c.electricity;
    var noActiveSupplies = !gas.some(function (supply) { return supply.isActive; }) &&
        !electricity.some(function (supply) { return supply.isActive; });
    var groupedElectricitySupplies = (0, utils_2.groupSupplies)(electricity);
    var isComplex = (0, utils_2.hasComplexSuppliesContext)(electricity);
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Heading1, null,
                react_1.default.createElement(Copy, { copyKey: "summaryHeading" }))),
        react_1.default.createElement(core_1.Feature, { feature: "meterSummary" }, function (enabled) {
            return enabled || isComplex ? (react_1.default.createElement(react_1.default.Fragment, null,
                groupedElectricitySupplies.map(function (_a) {
                    var msn = _a.msn, supplies = _a.supplies;
                    return (react_1.default.createElement(components_2.PopulatedMeterSummary, { key: getChildKey(msn), msn: msn, supplies: supplies, readings: readings.electricity, supplyIndexStart: (0, utils_2.getSupplyIndex)(electricity, supplies[0].mpxn), isComplex: isComplex, fuel: "electricity" }));
                }),
                gas.map(function (supply) { return (react_1.default.createElement(components_2.PopulatedMeterSummary, { key: getChildKey(supply.msn), msn: supply.msn, supplies: [supply], readings: readings.gas, isComplex: isComplex, fuel: "gas" })); }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                electricity.map(function (supply, index) { return (react_1.default.createElement(SupplySummaryCardContainer, { key: getChildKey(supply.mpxn), supplyIndex: index, supply: supply, noOfFuelSupplies: electricity.length, readings: (0, utils_2.filterReadsMPXN)(readings.electricity, supply.mpxn), fuelType: "electricity" })); }),
                gas.map(function (supply, index) { return (react_1.default.createElement(SupplySummaryCardContainer, { key: getChildKey(supply.mpxn), supplyIndex: index, supply: supply, noOfFuelSupplies: gas.length, readings: (0, utils_2.filterReadsMPXN)(readings.gas, supply.mpxn), fuelType: "gas" })); })));
        }),
        noActiveSupplies && (react_1.default.createElement(Card, null,
            react_1.default.createElement(InfoNotification, { id: "info-no-active-supplies", title: react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesTitle" }), "data-testid": "meter-readings-no-active-supplies" },
                react_1.default.createElement(Copy, { copyKey: "noActiveSuppliesMessage" }))))));
};
exports.MeterReadingsMain = (0, core_1.withCustomerAndAccountIds)(function () {
    var _a;
    var meterReads = core_1.configService.getConfig().meterReads;
    if (meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly) {
        return react_1.default.createElement(kapi_meter_reads_1.KapiMeterReadings, null);
    }
    return (react_1.default.createElement(components_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_SUMMARY, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(MeterReadingsWithData, null)));
});
